import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {Breadcrumbs, Container, Grid, Typography, Link, Paper} from "@mui/material";
import {Link as RouterLink, useHistory} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import GuestBar from "../../components/GuestInfo/GuestBar";
import PaymentCard from "../../components/GuestInfo/MyBooking/PaymentCard";
import GuestList from "../../components/GuestInfo/MyBooking/GuestList";
import ReservedRoom from "../../components/GuestInfo/MyBooking/ReservedRoom";
import GuestItinerary from "../../components/GuestInfo/MyBooking/GuestItinerary";
import Accommodation from "../../components/GuestInfo/MyBooking/Accommodation";
import SecondaryButton from "../../components/Common/SecondaryButton";
import PrimaryButton from "../../components/Common/PrimaryButton";
import NautilusTextInput from "../../components/Common/NautilusTextInput";
import {requestApi, showAlertAutoDis} from "../../utils/utils";
import {format, parse} from "date-fns";
import {useSignOut} from "react-auth-kit";
import {BookingPropTypes} from "../../utils/PropTypes/BookingPropTypes";
import {setTransactionNotes} from "../../redux/actions/transactionActions";


const BookingPage = () => {
	const transactions = useSelector(state => state.transactions);
	const [notes, setNotes] = useState(transactions?.notes || 'No special requests have been added to this booking');
    const [booking, setBooking] = useState({});
    const [guests, setGuests] = useState([]);
    const history = useHistory();
    const {id} = useParams();
    const signOut = useSignOut();
	const dispatch = useDispatch();

    useEffect(() => {
        getBookingAndGuestsById().catch();
    }, []);


    const getBookingAndGuestsById = async () => {
        try {
            const {data} = await requestApi(`/booking/get/${id}`);
            if (data.status === 'failed')
                return window.location = '/';
            	setBooking(data);
            const {data: guestData} = await requestApi(`/bookings/getGuests/${id}`);
            if (guestData.status === 'success')
                setGuests(guestData.guests);

        } catch (e) {
            if (e.status === 401)
                signOut();
        }
    };

    const saveNotes = async () => {
        if(!notes.includes('No special requests have been added to this booking')){
			dispatch(setTransactionNotes(notes));
			const {data: guestNotes} = await requestApi('/add-special-request', 'POST', {bookingId:id, specialRequest:notes});
			if (guestNotes.status === 'success') {
                return showAlertAutoDis({
                    title: 'Notes saved successfully',
                });
            }
		}
    }

    const goToMyBookings = () => {
        history.goBack();
    }

    return (
        <>
            <GuestBar>
                <Breadcrumbs aria-label="breadcrumb" separator={'>'}>
                    <Link component={RouterLink} underline="hover" color="inherit" to="/booking/my-bookings">
                        Bookings
                    </Link>
                    {booking?.booking?.tripDate && <Typography color="text.primary">
                        {format(parse(booking.booking.tripDate, 'yyyy-MM-dd', new Date()), 'LLLL d, yyyy')}
                    </Typography>}
                </Breadcrumbs>
            </GuestBar>
            {Object.keys(booking).length > 0 && <Container>
                <PaymentCard booking={booking}/>
                {guests.length > 0 && <GuestList guests={guests} bookingData={booking.booking} payments={booking.payments}/>}
                <Grid container sx={{px: {xs: '1.6rem', lg: '0'}}}>
                    {booking?.booking?.berths && <>
                        <Typography variant={"h3"} style={{marginTop: '50px'}}>Reserved Rooms</Typography>
                        {booking.booking.berths.map(berth => (
                            <ReservedRoom key={berth.index} room={berth}/>
                        ))}
                    </>}
                </Grid>

                <Grid container spacing={3} sx={{px: {xs: '1.6rem', lg: '0'}}}>
                    <Grid item xs={12} md={9}>
                        {guests.length > 0 && <GuestItinerary booking={booking} guests={guests}/>}
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Accommodation/>
                    </Grid>
                </Grid>
				<Paper sx={{marginTop: '50px', width: '100%'}}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} style={{marginLeft: '20px', marginRight: '20px'}}>
                            <Typography variant="h3" style={{fontWeight: '600', fontSize: '1.8rem'}}>
                                Do you have any Special Requests?
                            </Typography>
                            <Typography style={{marginTop: '10px'}}>
                                If this trip is for a special occasion, you've got special requests, or you have other
                                questions
                                about your trip, please let us know.
                            </Typography>
                        </Grid>
                        <Grid style={{margin: '20px', marginTop: '0'}} item xs={12}>
                            <NautilusTextInput
								onClick={() => notes.includes('No special requests have been added to this booking') && setNotes('')}
								fullWidth
								name="notes"
								value={notes}
								multiline
								minRows={3}
								onChange={(e) => setNotes(e.target.value)}
								label="Notes"
								variant="outlined"
							/>

                        </Grid>
                    </Grid>
					<Grid item xs={12} style={{padding: '0 20px 20px 20px'}}>
						<PrimaryButton style={{marginRight: '0px', whiteSpace: 'nowrap'}} onClick={saveNotes}>Save notes</PrimaryButton>
					</Grid>
                </Paper>
                <Grid style={{marginTop: '20px', marginBottom: '20px'}} sx={{mx: {xs: '1.6rem', lg: '0'}}}>
                    <SecondaryButton style={{letterSpacing: '2.5px'}} onClick={goToMyBookings}>Back</SecondaryButton>
                </Grid>
            </Container>}
        </>
    );
};

export default BookingPage;

BookingPage.propTypes = {
    booking: BookingPropTypes,
};